// Importing necessary utilities for styling
import {
  container,
  defaultFont,
  primaryColor,
  defaultBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor,
} from "assets/jss/material-dashboard-react";

// Defining styles for the header component
const headerStyle = theme => ({
  // Styles for the app bar
  appBar: {
    backgroundColor: "transparent", // Transparent background
    boxShadow: "none", // No shadow
    borderBottom: "0", // No bottom border
    marginBottom: "0", // No bottom margin
    position: "absolute", // Absolute positioning
    width: "99%", // Full width
    paddingTop: "10px", // Top padding
    color: grayColor[7], // Gray text color
    border: "0", // No border
    borderRadius: "3px", // Rounded corners
    padding: "10px 0", // Vertical padding
    transition: "all 150ms ease 0s", // Smooth transition
    minHeight: "50px", // Minimum height
    display: "block", // Block display
  },
  // Styles for the container
  container: {
    ...container, // Default container styles
    minHeight: "50px", // Minimum height
    paddingLeft: "0px", // No left padding
  },
  // Flexbox style
  flex: {
    flex: 1, // Flex-grow
  },
  // Styles for hiding the header
  hideHeader: {
    [theme.breakpoints.up("md")]: {
      width: "30%", // Width for medium screens
    },
    [theme.breakpoints.down("sm")]: {
      width: "auto", // Auto width for small screens
    },
  },
  // Styles for the title
  title: {
    ...defaultFont, // Default font styles
    letterSpacing: "unset", // No letter spacing
    lineHeight: "30px", // Line height
    marginLeft: "-10px", // Left margin
    fontSize: "18px", // Font size
    borderRadius: "3px", // Rounded corners
    textTransform: "none", // No text transformation
    color: "inherit", // Inherit text color
    margin: "0", // No margin
    "&:hover,&:focus": {
      background: "transparent", // Transparent background on hover/focus
    },
  },
  // Styles for responsive app bar
  appResponsive: {
    top: "8px", // Top position
  },
  // Styles for primary header
  primary: {
    backgroundColor: primaryColor[0], // Primary background color
    color: whiteColor, // White text color
    ...defaultBoxShadow, // Default box shadow
  },
  // Styles for info header
  info: {
    backgroundColor: infoColor[0], // Info background color
    color: whiteColor, // White text color
    ...defaultBoxShadow, // Default box shadow
  },
  // Styles for success header
  success: {
    backgroundColor: successColor[0], // Success background color
    color: whiteColor, // White text color
    ...defaultBoxShadow, // Default box shadow
  },
  // Styles for warning header
  warning: {
    backgroundColor: warningColor[0], // Warning background color
    color: whiteColor, // White text color
    ...defaultBoxShadow, // Default box shadow
  },
  // Styles for danger header
  danger: {
    backgroundColor: dangerColor[0], // Danger background color
    color: whiteColor, // White text color
    ...defaultBoxShadow, // Default box shadow
  },
});

export default headerStyle;
